import flatpickr from 'flatpickr';
import {German} from 'flatpickr/dist/l10n/de';
import tippy from 'tippy.js';

const axios = require('axios/dist/browser/axios.cjs');

class Delivery
{
    constructor($el)
    {
        this.$el = $el;

        window.$ = jQuery;

        Delivery.handleAddToCartButtons();

        this.initSelection();
    }

    static handleAddToCartButtons()
    {
        const selector = '.add_to_cart_button, .single_add_to_cart_button';

        $('.add_to_cart_button').removeClass('ajax_add_to_cart');

        $('body')
            .on('click', selector, e =>
            {
                e.preventDefault();

                e.target.stopPropagation();
            });

        tippy(selector, {
            theme: 'light',
            hideOnClick: false,
            content: mylunch.notices.add_to_cart,
        });
    }

    initSelection()
    {
        this.$form = this.$el.find('.ml-delivery-selection');
        this.$submit = this.$form.find('button');

        this.$date = this.$el.find('.ml-date');
        this.$postcode = this.$el.find('.ml-postcode');
        this.$timeframe = this.$el.find('.ml-timeframe');

        this.initPostcodeSelection();

        this.initDateSelection();

        this.initTimeframeSelection();

        this.$form.submit(this.onSubmit.bind(this));

        this.$form.fadeTo(200, 1);
    }

    initPostcodeSelection()
    {
        this.$postcode.select2({
            placeholder: '<i class="fas fa-map-marker-alt"></i>' + mylunch.labels.postcode,
            escapeMarkup: (markup) => markup,
            data: mylunch.postcodes.map((postcode) => ({
                id: postcode.postcode,
                text: postcode.postcode,
                min_total: postcode.min_total,
            })),
        });

        this.$postcode.change(this.onSelect2Change.bind(this));
    }

    async initDateSelection()
    {
        const exceptions = await this.fetchDates();

        this.datePicker = flatpickr(this.$date[0], {
            locale: German,
            dateFormat: 'Y-m-d',
            altFormat: 'd.m.Y',
            altInput: true,
            minDate: (new Date()).fp_incr(2),
            maxDate: (new Date()).fp_incr(180),
            disable: [
                (date) =>
                {
                    const day = date.getDay();

                    return mylunch.timeframes[day].length === 0;
                },
                (date) =>
                {
                    const ymd = date.toLocaleDateString('fr-CA');

                    return (exceptions[ymd] ?? '') === 'blocked'; 
                },
                (date) =>
                {
                    // if current day is friday and time is later than 14:00, then disable the next monday in the datepicker
                    let currentDay = new Date();

                    if (currentDay.getDay() === 5 && currentDay.getHours() >= 14 && date.getDay() === 1)
                    {
                        let dayDifference = Math.ceil((date.getTime() - currentDay.getTime())) / (1000 * 3600 * 24);

                        if (dayDifference <= 3)
                        {
                            return true;
                        }
                    }

                    return false;
                    // ========================================
                },
            ],
            onChange: this.onDateChange.bind(this),
        });

        this.selectedDay = null;
    }

    initTimeframeSelection()
    {
        let data = [];

        if (this.selectedDay)
        {
            data = mylunch.timeframes[this.selectedDay].map((timeframe) => ({
                id: timeframe.start,
                text: `${timeframe.start} - ${timeframe.end}`,
                start: timeframe.start,
                end: timeframe.end,
            }));

            for (let i = 0; i < data.length; i++)
            {
                let date = this.datePicker.formatDate(
                    this.datePicker.selectedDates[0], 'Y-m-d'
                );

                date = new Date(`${date} ${data[i].start}`);

                if (date.getTime() - Date.now() < 144000000) // 48 * 3600 * 1000
                {
                    delete data[i];
                }
            }
        }

        this.$timeframe.find('option:not(:first-child)')
            .remove();

        this.$timeframe.select2({
            data,
            placeholder: '<i class="fas fa-clock"></i>' + mylunch.labels.timeframe,
            escapeMarkup: (markup) => markup,
            minimumResultsForSearch: -1,
            language: {
                noResults: () => mylunch.notices.no_timeframes,
            },
        });

        this.$timeframe.change(this.onSelect2Change.bind(this));
    }

    fetchDates()
    {
        return axios.get(mylunch.date_api)
            .then((response) => response.data);
    }

    onDateChange()
    {
        const day = this.getSelectedDay();

        const lastDay = this.selectedDay;

        this.selectedDay = day;

        if (lastDay !== day)
        {
            this.selectedDay = day;

            this.initTimeframeSelection();

            this.$timeframe.val('')
                .trigger('change');
        }

        this.$timeframe.prop('disabled', false);
    }

    onSelect2Change()
    {
        const postcode = this.$postcode.val() ?? '';
        const timeframe = this.$timeframe.val() ?? '';

        const valid = postcode.length && timeframe.length;

        this.$submit.prop('disabled', !valid);
    }

    getSelectedDay()
    {
        return this.datePicker.selectedDates[0].getDay();
    }

    onSubmit(e)
    {
        e.preventDefault();

        const postcode = this.$postcode.select2('data')[0];
        const timeframe = this.$timeframe.select2('data')[0];

        const data = {
            action: 'my-lunch-delivery-update',
            date: this.$date.val(),
            postcode: {
                postcode: postcode.id,
                min_total: postcode.min_total,
            },
            timeframe: {
                start: timeframe.start,
                end: timeframe.end,
            },
        };

        $.post(mylunch.ajax_url, data, () =>
        {
            window.location = mylunch.current_url;
        });
    }
}

jQuery($ =>
{
    $('[id^="delivery-"]')
        .each((i, el) =>
        {
            new Delivery($(el));
        });
});
